var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check-sq-fr 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.99805 15.6706C4.99805 11.9369 4.99805 10.07 5.72466 8.64397C6.36383 7.38956 7.3837 6.36969 8.63811 5.73052C10.0642 5.00391 11.931 5.00391 15.6647 5.00391H24.3314C28.065 5.00391 29.9319 5.00391 31.358 5.73052C32.6124 6.36969 33.6322 7.38956 34.2714 8.64397C34.998 10.07 34.998 11.9369 34.998 15.6706V24.3372C34.998 28.0709 34.998 29.9377 34.2714 31.3639C33.6322 32.6182 32.6124 33.6381 31.358 34.2772C29.9319 35.0039 28.065 35.0039 24.3314 35.0039H15.6647C11.931 35.0039 10.0642 35.0039 8.63811 34.2772C7.3837 33.6381 6.36383 32.6182 5.72466 31.3639C4.99805 29.9377 4.99805 28.0709 4.99805 24.3372V15.6706Z",
    fill: "#FF7228",
    fillOpacity: 0.15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentUnchecked);
export default __webpack_public_path__ + "static/media/PaymentUnchecked.829089b1a5b47b1fdce6185f2b9c7b0c.svg";
export { ForwardRef as ReactComponent };